import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@DATATYPE', (value: string, c11nEnv: C11nEnv) => {
  return c11nEnv.getValue(value);
});
